import { css } from 'styled-components';
import { colors, spacing, borderRadius } from '@izettle/otto';

const getActionStateColors = (actionColorKey, state) => css`
  border-color: ${colors.action[actionColorKey].border[state]};
  background: ${colors.action[actionColorKey].background[state]};
  color: ${colors.action[actionColorKey].text[state]};
`;
const getActionColors = actionColorKey => css`
  ${getActionStateColors(actionColorKey, "default")};
  &:hover {
    ${getActionStateColors(actionColorKey, "hover")};
  }
  &:active {
    ${getActionStateColors(actionColorKey, "selected")};
  }
  &:disabled {
    ${getActionStateColors(actionColorKey, "disabled")};
  }
`;
const resetFocusMixin = css`
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
`;
const focusOutlineMixin = css`
  outline: ${colors.border.focusForm} solid 1px;
`;
const getHorizontalPaddingAndBorderWidth = space => borderWidth => css`
    padding: 0 calc(${spacing[space]} - ${borderWidth});
    border-width: ${borderWidth};
  `;
const ACTION_FOCUS_COLOR_VAR = "--action-focus-color";

/**
 * Use together with `actionFocusMixin` to edit the css variable used for the color of
 * the focus ring. Only use within the scope of a specific component, or it will impact
 * the focus ring color of the whole page.
 */
const setActionFocusColorMixin = color => `${ACTION_FOCUS_COLOR_VAR}: ${color}`;

/**
 * Replaces the default focus styles of the browser with a nice focus ring. Use within the
 * `:focus` selector of your components styles.
 *
 * Uses the `::before` selector to insert the focus ring, so make sure that the component is
 * not already using the same selector for something diferent.
 *
 * Use the `MouseClickFocusRemover` component inside the component to only apply the focus
 * styles on keyboard navigation.
 *
 * Edit the color of the focus ring using the `setActionFocusColorMixin` within the styles
 * of your component.
 */
const actionFocusMixin = css`
  ${resetFocusMixin}

  &:before {
    content: "";
    pointer-events: none;
    box-sizing: border-box;
    position: absolute;
    border: 1px solid var(${ACTION_FOCUS_COLOR_VAR}, ${colors.border.focusForm});
    height: calc(100% + 8px);
    width: calc(100% + 8px);
    top: -4px;
    left: -4px;
    border-radius: ${borderRadius.large};
    z-index: 1;
  }
`;
// prettier-ignore
const marginTopBottomMixin = _ref => {
  let {
    top,
    bottom
  } = _ref;
  return css`
  ${_ref2 => {
    let {
      marginTop = top
    } = _ref2;
    return marginTop ? `margin-top: ${spacing[marginTop]};` : "";
  }}
  ${_ref3 => {
    let {
      marginBottom = bottom
    } = _ref3;
    return marginBottom ? `margin-bottom: ${spacing[marginBottom]};` : "";
  }}
`;
};

export { actionFocusMixin, focusOutlineMixin, getActionColors, getActionStateColors, getHorizontalPaddingAndBorderWidth, marginTopBottomMixin, resetFocusMixin, setActionFocusColorMixin };
//# sourceMappingURL=mixins.js.map
